import { collection, doc, getDoc, getDocs, limit, orderBy, query } from "firebase/firestore";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import Failure from "../../../core/Failure";
import { INumber, INumberHistory } from "@leedpulse-monorepo/interfaces";

async function getNumberById(numberId: string): Promise<INumber | null> {
  try {
    const db = firestore;

    const numberRef = await getDoc(
      doc(db, FirestoreCollections.numbers, numberId)
    );

    if (!numberRef.exists()) {
      return null;
    }

    const historyQuery = await getDocs(query(
      collection(db, FirestoreCollections.numbers, numberId, FirestoreCollections.numbers_history),
      orderBy('timestamp', 'desc'),
      limit(10)
    ));

    const history: INumberHistory[] = historyQuery.docs.map(doc => doc.data() as INumberHistory);

    const number = numberRef.data() as INumber;
    number.history = history;

    return number;
  } catch (e) {
    console.log("error: ", e);
    throw new GetNumberByIdFailure();
  }
}

export class GetNumberByIdFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default getNumberById;
